function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import { EmailIcon, LockIcon, ProfileIcon } from '@domain-group/fe-co-icon';
import * as styles from './user-input.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class UserInput extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleChange", event => {
      this.props.onValueChange(event);
    });
    _defineProperty(this, "displayIcon", iconName => {
      if (iconName === 'email') {
        return ___EmotionJSX(EmailIcon, {
          size: "regular",
          css: styles.inputIcon
        });
      }
      if (iconName === 'lock') {
        return ___EmotionJSX(LockIcon, {
          size: "regular",
          css: styles.inputIcon
        });
      }
      return ___EmotionJSX(ProfileIcon, {
        size: "regular",
        css: styles.inputIcon
      });
    });
    _defineProperty(this, "displayHint", () => ___EmotionJSX("button", {
      type: "button",
      css: styles.toggleButton,
      onClick: this.toggleInputType
    }, this.state.type === 'password' ? 'Show' : 'Hide'));
    _defineProperty(this, "toggleInputType", () => {
      this.setState(prevstate => ({
        type: prevstate.type === 'input' ? 'password' : 'input'
      }));
    });
    this.state = {
      type: this.props.fieldType
    };
  }
  render() {
    return ___EmotionJSX("div", {
      css: styles.textFieldWrapper
    }, this.displayIcon(this.props.iconName), ___EmotionJSX("input", _extends({
      type: this.state.type,
      name: this.props.fieldName,
      placeholder: this.props.placeHolder,
      value: this.props.fieldValue,
      onChange: this.handleChange,
      css: this.props.fieldError ? styles.inputStyleError : styles.inputStyle
    }, this.props.focus ? {
      autoFocus: true
    } : {}, {
      onKeyPress: event => {
        // Call submit form handler when enter key is pressed
        if (event.which === 13) {
          event.preventDefault();
          this.props.onSubmit();
          return false;
        }
        return true;
      }
    })), this.props.fieldType === 'password' && this.displayHint(), this.props.children, this.props.fieldError ? ___EmotionJSX("div", {
      css: styles.errorMessage
    }, this.props.fieldError) : false);
  }
}
UserInput.propTypes = {
  iconName: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  fieldType: PropTypes.string.isRequired,
  placeHolder: PropTypes.string,
  fieldValue: PropTypes.string,
  fieldError: PropTypes.string,
  onValueChange: PropTypes.func,
  onSubmit: PropTypes.func,
  focus: PropTypes.bool,
  children: PropTypes.node
};
UserInput.defaultProps = {
  placeHolder: '',
  fieldValue: '',
  fieldError: '',
  onValueChange: () => {},
  onSubmit: () => {},
  focus: false,
  children: null
};
export default UserInput;